var _path, _path2, _g, _path3, _path4, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.4 3.2 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 58 L18 20",
    stroke: "#6b4428",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 58 L18 20",
    stroke: "#b07a52",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 20) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21 8 Q-12 -6 0 -6 Q12 -6 21 8 L19 9.5 Q11 -1.5 0 -1.5 Q-11 -1.5 -19 9.5Z",
    fill: "#5a6068",
    stroke: "#2a2d30",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5,
    y: -7.5,
    width: 7,
    height: 9,
    rx: 1.2,
    fill: "#3d4247",
    stroke: "#2a2d30",
    strokeWidth: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 58 L42 24",
    stroke: "#6b4428",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 58 L42 24",
    stroke: "#b07a52",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 61 L11 55",
    stroke: "#3a2a1a",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.5 15.5) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8 7 L-8 -4 Q-8 -11 0 -15 Q8 -11 8 -4 L8 7Z",
    fill: "#c4d0db",
    stroke: "#6f7f8c",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 7 L3 7 L2 12 L-2 12Z",
    fill: "#7d8a96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -12 L0 4",
    stroke: "#9aa8b4",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.7b7cba128ee0a523e24cb46777dfe058.svg";
export { ForwardRef as ReactComponent };